import React from 'react';
import useSeo from '../lib/seo';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import PageHero from '../components/site/PageHero';

function NotFound() {
  // A 404 não deve ser indexada.
  useSeo({ title: 'Página não encontrada | Idealizer', path: '/404', noindex: true });

  return (
    <main className="pg">
      <PageHero
        lines={['Esta página', { text: 'não existe.', accent: true }]}
        lede="O endereço pode ter mudado ou ter sido digitado errado. Siga por um destes caminhos."
      >
        <Link to="/" className="btn-primary">
          Ir para o início <ArrowRight size={18} strokeWidth={2} aria-hidden />
        </Link>
        <Link to="/nosso-trabalho" className="btn-ghost">
          Ver projetos
        </Link>
      </PageHero>
    </main>
  );
}

export default NotFound;
